import React, { Component } from 'react';

import checkIcon from '../../../../../assets/images/checkButton.svg';
import commentIcon from '../../../../../assets/images/comment-ico.svg';

export default class Button extends Component {
  render() {
    const { questionId, text, name } = this.props;
    let button = null;
    if (this.props.type === "question") {
      button = <button
        onClick={e => this.props.onClick(e)}
        className={this.props.isActive ? 'button-question-active' : 'button-question'}
        id={questionId}
        name={name.toLowerCase()}>
        {this.props.icon ? <img className="icon-question-button" src={checkIcon} alt="" /> : ''}
        {text}
      </button>
    }
    else {
      button = <button
        onClick={e => this.props.onClick(e)}
        className={this.props.styleButton }
        id={questionId}
        name={name.toLowerCase()}>
        {this.props.icon ? <img className="icon-comment-button" src={commentIcon} alt="" /> : ''}
        {text}
      </button>
    }
    return (
      button
    );
  }
}



// WEBPACK FOOTER //
// ./src/screens/Question/components/QuestionItem/Button/Button.js